<template>
    <li class="qty">
        <div class="qty__col" v-if="renderLabel">
            <span class="qty__title" v-if="label">{{ label }}</span>
            <span class="qty__subtitle" v-if="sublabel">{{ sublabel }}</span>
        </div>
        <div v-if="price > 0" class="qty__col">
            <span class="qty__price">{{ this.price | toCurrency }}</span>
        </div>
        <div class="qty__col">
            <div class="qty__row">
                <div class="qty__col4">
                    <span :id="`qty-${id}-dec`" v-on:click="decrease()" class="qty__btn qty__btn--down " :class="{ disabled: checkValMin }">
                        <i class="fal fa-minus"></i>
                    </span>
                </div>
                <div class="qty__col4">
                    <input :id="`qty-${id}`" type="number" :name="`qty-${id}`" v-model="data" :min="`${min}`" :max="max" class="d-none" disabled />
                    <div class="qty__input">
                        <transition name="bounce" mode="out-in">
                            <div :key="data">{{ data }}</div>
                        </transition>
                    </div>
                </div>
                <div class="qty__col4">
                    <span :id="`qty-${id}-inc`" v-on:click="increase()" class="qty__btn qty__btn--up" :class="{ disabled: checkValMax }">
                        <i class="fal fa-plus"></i>
                    </span>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'QtyIncDec',
    props: {
        value: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: 'name'
        },
        component: {
            type: String,
            default: 'component'
        },
        label: {
            type: String,
            default: null
        },
        sublabel: {
            type: String,
            default: null
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 10
        },
        price: {
            type: Number,
            default: 0
        }
    },
    methods: {
        increase() {
            if (this.data < this.max) {
                this.data++;
            }
            this.$emit('value-changed', { value: this.data, name: this.name });
        },
        decrease() {
            if (this.data > this.min) {
                this.data--;
            }
            this.$emit('value-changed', { value: this.data, name: this.name });
        }
    },
    computed: {
        id() {
            return this.name + '-' + this.component;
        },
        checkValMin: function() {
            return this.data === this.min;
        },
        checkValMax: function() {
            return this.data === this.max;
        },
        renderLabel: function() {
            return this.label !== null;
        }
    },
    created() {
        this.data = this.value;
    },
    data() {
        return {
            data: null
        };
    },
    watch: {
        max: function() {}
    }
};
</script>
